import { useAppBack } from '../../hooks/useAppBack';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { NmMenuCard, NmMenuPickRow } from '../../components/NmMenuList';
import { SettingsPageHeader } from './SettingsPageHeader';
import { IoGlobeOutline } from 'react-icons/io5';
import { useLocale } from '../../hooks/useLocale';
import type { AppLocale } from '../../i18n/config';

/** Language picker — same card pattern as other settings rows. */
export function MobileLanguageSettingsPage() {
  const { t } = useTranslation();
  const goBack = useAppBack('/settings');
  const { locale, labels, supportedLocales, setLocale } = useLocale();

  const handlePick = (code: AppLocale) => {
    if (code === locale) {
      goBack();
      return;
    }
    void setLocale(code).then(() => goBack());
  };

  return (
    <div className="mobile-screen mobile-settings-screen">
      <SettingsPageHeader
        title={t('settings.language', 'Language')}

        icon={IoGlobeOutline}
        onBack={goBack}
      />

      <p className="nm-menu-pick-hint">{t('settings.languageHint', 'Choose app display language')}</p>

      <NmMenuCard>
        {supportedLocales.map((code, index) => (
          <NmMenuPickRow
            key={code}
            label={labels[code]}
            selected={locale === code}
            onClick={() => handlePick(code)}
            last={index === supportedLocales.length - 1}
          />
        ))}
      </NmMenuCard>
    </div>
  );
}
